import {
  SelectableLocationsDocument,
  SelectableLocationsEmployeesDocument,
  SelectableLocationsQuery,
} from 'generated/resources/graphql'
import compact from 'lodash/compact'
import concat from 'lodash/concat'
import uniq from 'lodash/uniq'

import { useQuery } from 'modules/core/hooks/useQuery'

const sortedLocations = (dataLocations: SelectableLocationsQuery) =>
  dataLocations.locations.locations
    .map(({ id, name }) => ({
      id,
      name,
    }))
    .sort(({ name: nameA }, { name: nameB }) => nameA.localeCompare(nameB))

export const useAllLocations = () => {
  const { data: dataLocations, loading } = useQuery(SelectableLocationsDocument, {
    variables: {
      employeeIds: [],
    },
  })

  return {
    loading,
    locations: dataLocations ? sortedLocations(dataLocations) : [],
  }
}

export const useSelectableLocations = (employeeId: number, showAll: boolean) => {
  const { data, loading } = useQuery(SelectableLocationsEmployeesDocument, {
    variables: {
      employeeId: employeeId,
    },
    skip: showAll,
  })

  const hierarchyEmployeeIds =
    data && data.employees.employee
      ? uniq(
          concat(
            data.employees.employee.reports.map((report) => report.id),
            compact(
              data.employees.employee.memberships
                .flatMap(({ team }) => team)
                .filter((team) => team?.leadIds && team?.leadIds.includes(employeeId))
                .flatMap((team) => team?.employeeIds)
            )
          )
        )
      : []

  const { data: dataLocations, loading: loadingLocations } = useQuery(SelectableLocationsDocument, {
    variables: {
      employeeIds: hierarchyEmployeeIds,
    },
    skip: loading && !showAll,
  })

  return {
    loading: loading || loadingLocations,
    locations: dataLocations ? sortedLocations(dataLocations) : [],
  }
}
